<template>
  <header class="app-header">
    <div class="container">
      <div class="header-content">
        <router-link to="/" class="logo-link">
          <img :src="headerLogoSrc" alt="Logo" class="logo-img" @error="handleLogoError" />
        </router-link>
        <nav class="main-nav">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/mo_course" class="nav-link">全部课程</router-link>
          <router-link to="/course" class="nav-link">公开课</router-link>
          <router-link to="/live" class="nav-link">云课直播</router-link>
          <!-- <router-link to="/news" class="nav-link">新闻资讯</router-link> -->
          <a href="https://szzy.yinghuaonline.com/" target="_blank" class="nav-link">数图资源</a>
        </nav>

        <div class="user-actions">
          <button @click="handleTeacherLogin" class="btn btn-outline">教师登录</button>
          <button @click="handleStudentLogin" class="btn btn-primary">学生登录</button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { useUserStore } from '@/stores/user'
import { useSchoolStore } from '@/stores/school'
import { useRouter } from 'vue-router'
import { getToken, isLoggedIn as checkIsLoggedIn } from '@/utils/auth'
import { computed } from 'vue'

export default {
  name: 'AppHeader',
  setup() {
    const router = useRouter()
    const userStore = useUserStore()
    const schoolStore = useSchoolStore()
    const defaultLogoSrc = `${process.env.BASE_URL}commonPic/topLogo.png`

    const normalizeText = (value) => String(value ?? '').replace(/`/g, '').trim()
    const normalizeLogoUrl = (value) => {
      const raw = normalizeText(value)
      if (!raw) return ''
      if (/^(https?:)?\/\//i.test(raw)) return raw
      if (/^\/\//.test(raw)) return `https:${raw}`
      if (raw.startsWith('/')) return raw
      return raw
    }

    const headerLogoSrc = computed(() => {
      const logo = normalizeLogoUrl(schoolStore.getCurrentSchool?.logo)
      return logo || defaultLogoSrc
    })

    const handleLogoError = (event) => {
      event.target.src = defaultLogoSrc
    }

    // 检查登录状态和跳转逻辑
    const checkLoginAndRedirect = (userType) => {
      userStore.initializeUserState()
      const loginData = userStore.getLoginData
      if (userType === 'student') {
        const studentToken = localStorage.getItem('student_token')
        if (studentToken) {
          router.push('/student/home')
          return true
        }
        router.push('/student/login')
        return false
      }
      if (userType === 'teacher') {
        const currentUserType = loginData?.userType
        if ((currentUserType === 'teacher' || currentUserType === 'admin') && !userStore.checkLoginTimeout()) {
          router.push(currentUserType === 'admin' ? '/admin' : '/teacher')
          return true
        }
        router.push('/teacher/login')
        return false
      }
      router.push('/')
      return false
    }

    // 教师登录按钮处理
    const handleTeacherLogin = () => {
      checkLoginAndRedirect('teacher')
    }

    // 学生登录按钮处理
    const handleStudentLogin = () => {
      checkLoginAndRedirect('student')
    }

    return {
      handleTeacherLogin,
      handleStudentLogin,
      headerLogoSrc,
      handleLogoError
    }
  }
}
</script>

<style scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}



.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.logo-link {
  display: flex;
  align-items: center;
  margin-right: 5.3125rem;
}

.logo-img {
  height: 60px;
  width: auto;
  object-fit: contain;
}

.main-nav {
  display: flex;
  gap: 2.5rem;
  flex: 1;
  justify-content: flex-start;
  min-width: 450px;
}

.nav-link {
  text-decoration: none;
  color: var(--text-color);
  font-weight: 500;
  transition: color 0.3s ease;
  position: relative;
}

.nav-link:hover, .nav-link.router-link-active {
  color: var(--primary-color);
}

.nav-link.router-link-active::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--primary-color);
}

.user-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
  justify-content: flex-end;
}

.btn {
  padding: 8px 16px;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.btn-primary {
  background-color: var(--primary-color, #409eff);
  color: white;
}

.btn-primary:hover {
  background-color: var(--primary-color-hover, #66b1ff);
}

.btn-outline {
  background-color: transparent;
  color: var(--primary-color, #409eff);
  border: 1px solid var(--primary-color, #409eff);
}

.btn-outline:hover {
  background-color: var(--primary-color, #409eff);
  color: white;
}

@media (max-width: 1200px) {
  .main-nav {
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .header-content {
    padding: 0 10px;
  }
  
  .logo-link {
    margin-right: 1rem;
  }
  
  .logo-img {
    height: 35px;
  }
  
  .main-nav {
    display: none;
  }
}
</style>
